import i18n from "i18next";
import { faProjectDiagram } from "@fortawesome/pro-regular-svg-icons";
import { AsyncButton, AsyncButtonProps } from "src/components/common/buttons/AsyncButton.tsx";
import { useGenericDialog } from "src/components/common/dialogs/GenericDialogContext.ts";
import { ProjectTreeViewContainer } from "src/components/views/erp/project/treeView/ProjectTreeViewContainer.tsx";
import { defineAgentUiContextKey } from "src/components/views/ai/assistant/uiContext/agentUiContextKey.ts";

export interface OpenCustomerOrderProjectInTreeViewButtonProps extends Omit<AsyncButtonProps, "onClick"> {
	customerOrderId: number;
}

export const OpenCustomerOrderProjectInTreeViewButton = ({
	customerOrderId,
	variant = "menu",
	...other
}: OpenCustomerOrderProjectInTreeViewButtonProps) => {
	const { openDialog } = useGenericDialog();
	return (
		<AsyncButton
			label={i18n.t("open_project")}
			icon={faProjectDiagram}
			variant={variant}
			onClick={async () => {
				openDialog({
					title: i18n.t("project"),
					agentContext: {
						key: defineAgentUiContextKey("erp.project.customerOrderProject.dialog"),
						data: { customerOrderId },
						pathSegments: [i18n.t("project")],
					},
					content: <ProjectTreeViewContainer customerOrderId={customerOrderId} />,
				});
			}}
			{...other}
		/>
	);
};
